type Props = { size?: number; color?: string };

export function IconMail({ size = 18, color = "currentColor" }: Props) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokeWidth="1.8"
			strokeLinejoin="round"
			aria-hidden="true"
		>
			<rect x="2.5" y="5" width="19" height="14" rx="3" />
			<path d="M3.5 7l8.5 6 8.5-6" />
		</svg>
	);
}
